import axios from 'axios';
import { config } from '../../../../config';

const auth = axios.create({ baseURL: config.API_AUTH });
const fiscal = axios.create({ baseURL: config.API_FISCAL });

async function setToken() {
	return auth.post('', {
		username: config.USER_AUTHENTICATION_DEV,
		password: config.USER_AUTHENTICATION_PASS_DEV,
	});
}

async function getDirf(token, ec) {
	const uri = `/dirf/${ec}`;
	return fiscal.get(uri, {
		headers: { 'Content-Type': 'application/json', Authorization: token },
	});
}

const apiDift = {
	setToken,
	fiscal: {
		getDirf,
	},
};

export default apiDift;
